import { Component, EventEmitter, Inject, OnInit, Output } from '@angular/core';
import { FormBuilder } from '@angular/forms';
import { HelpersService } from '../../../../core/services/helpers.service';
import { OperationsService } from '../../../../core/services/operations.service';
import { LettereDiffidaEsitoSpedizioneForm } from '../../../form/lettera-diffida-esito-spedizione-form';
import { SezioneLettereDiffidaResponse } from '../../../models/dto/sezione-lettere-diffida-response';
import { EsitoSpedizioneDiffida } from '../../../models/esito-spedizione-diffida';

@Component({
    selector: 'div [lettera-diffida-esito-spedizione-form-update]',
  templateUrl: '../../../form/lettera-diffida-esito-spedizione-form.html',
  host: { '[class.col-sm-12]': '\'true\'', '[class.coldx]': '\'true\'' }
})
export class LettereDiffidaEsitoSpedizioneUpdate extends LettereDiffidaEsitoSpedizioneForm implements OnInit {

  @Output() onReturn: EventEmitter<void> = new EventEmitter<void>();
  idLetteraDiffida: string;
  updateUrl: string;
  originalEsitoSpedizione: EsitoSpedizioneDiffida;
  idSezione: string;
  constructor(@Inject(HelpersService) helpers: HelpersService, @Inject(OperationsService) operationService, @Inject(FormBuilder) campiForm) {
        super(helpers, operationService, campiForm);
  }

  ngOnInit() {
    this.setTitle('Modifica Esito Spedizione');
    this.isInserimento(false);
  }

  inizializza(updateUrl: string, idLetteraDiffida: string, idSezione: string, esitoSpedizione: EsitoSpedizioneDiffida) {
    this.idSezione = idSezione;
    this.idLetteraDiffida = idLetteraDiffida;
    this.updateUrl = updateUrl;
    this.originalEsitoSpedizione = esitoSpedizione;
    this.populateSelect();
    this.createForm();
  }

  getEsitoSpedizioneLetteraDiffida(): EsitoSpedizioneDiffida {
    return this.originalEsitoSpedizione;
  }

  getRequest(esitoSpedizione: EsitoSpedizioneDiffida) {
    this.operationsService.updateLetteraDiffida(this.updateUrl, this.idLetteraDiffida, this.idSezione, esitoSpedizione).subscribe((response: any) => this.returnSetSezLettereDiffida(response));
  }

  returnSetSezLettereDiffida(response: SezioneLettereDiffidaResponse) {
    if (response.returnCode === 'OK') {
      this.onReturn.emit();
    }
  }
}
